import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { pedagogueTokens } from "@pedagogue/ui-core";
import type { SurveyWaveSummary } from "../overviewTypes";
import { SURVEY_WAVE_LABELS } from "../overviewTypes";

interface Props { waves: SurveyWaveSummary[]; field: "weeklyBands" | "timeBands"; labels: Record<string, string>; title: string }
const colours = [pedagogueTokens.mist, pedagogueTokens.rule, pedagogueTokens.chartOrange, pedagogueTokens.chartBlue, pedagogueTokens.chartGreen];

export default function SurveyBandChart({ waves, field, labels, title }: Props) {
  const bands = Object.keys(labels);
  const rows = waves.filter(wave => bands.length === 5 && wave[field].length === 5 && bands.every(id => {
    const metric = wave[field].find(band => band.id === id)?.value;
    return metric?.value !== null && metric?.value !== undefined && metric.status === "ready";
  })).map(wave => ({ name: SURVEY_WAVE_LABELS[wave.wave], ...Object.fromEntries(wave[field].map(band => [band.id, band.value.value])) }));
  if (!rows.length) return <p className="mt-3 text-sm text-pd-slate">{title} bands are not available for this selection. Partial or withheld bands are not drawn as a complete distribution.</p>;
  return <div className="mt-3 h-[260px] min-w-0" role="img" aria-label={`${title} bands by survey wave`}>
    <ResponsiveContainer width="100%" height={260} initialDimension={{ width: 600, height: 260 }}>
      <BarChart data={rows} layout="vertical" margin={{ top: 8, right: 16, left: 0, bottom: 12 }}>
        <XAxis type="number" domain={[0, 100]} unit="%" tick={{ fontSize: 12, fill: pedagogueTokens.slate }} />
        <YAxis type="category" dataKey="name" width={90} tick={{ fontSize: 12, fill: pedagogueTokens.slate }} />
        <Tooltip formatter={value => `${value}%`} /><Legend itemSorter={() => 0} formatter={value => <span style={{ color: pedagogueTokens.ink }}>{value}</span>} wrapperStyle={{ fontSize: 12 }} />
        {bands.map((id, index) => <Bar key={id} dataKey={id} name={labels[id]} stackId="bands" fill={colours[index]} isAnimationActive={false} />)}
      </BarChart>
    </ResponsiveContainer>
  </div>;
}
